import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  showNav = true;

  constructor(
    private route: ActivatedRoute,
  ) {
    if (window.frameElement) {
      this.showNav = false;
    }
  }

  ngOnInit() {
  }

}
